<i18n locale="en">
{
  "defaults": {
    "headline": "Heading",
    "subheading": "Subheading"
  }
}
</i18n>

<template>
  <PreviewSheet class="headline-preview" border="primary" radius="0">
    <div class="flex-col">
      <PreviewTypographyLegacy
        class="headline-preview__text"
        :text="text"
        :variant="variant"
        :color="color"
      />
    </div>
  </PreviewSheet>
</template>

<script>
import { useI18n } from 'vue-i18n'

import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

export default {
  name: 'HeadlinePreview',
  components: {
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  props: {
    content: { type: Object, default: undefined },

    /**
     * Override data for out of module rendering contexts
     */
    populatedData: { type: Object, default: undefined },
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    color() {
      const { currentBlock } = this

      return currentBlock?.params?.text ? 'primary' : 'placeholder'
    },
    currentBlock() {
      const { content, populatedData } = this

      return populatedData ?? content
    },
    text() {
      const { currentBlock } = this

      return (
        currentBlock?.params?.text || this.t(`defaults.${currentBlock?.type}`)
      )
    },
    variant() {
      const { currentBlock } = this

      return currentBlock?.type === 'subheading'
        ? 'paragraphRegular'
        : 'heading2'
    },
  },
}
</script>

<style lang="scss" scoped>
.headline-preview {
  padding: 12px 40px;

  &__text {
    white-space: pre-wrap;
  }
}
</style>
